
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact/support",
      function () {
        return require("private-next-pages/contact/support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact/support"])
      });
    }
  